const API_BASE = 'https://ya-praktikum.tech/api/v2';

export default API_BASE;
